<template>
  <v-card :style="backOpacity">
    <v-card-title>時刻入力 TimeInputForm.vue</v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="4">
            <v-text-field
              label="ラベル名"
              v-model="returnData.label"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-radio-group label="" v-model="rules[4]" row>
              <v-radio label="デフォルト" value="null"></v-radio>
              <v-radio label="小型" value="small"></v-radio>
            </v-radio-group>
          </v-col>
          <!-- cols -->
          <v-col cols="4">
            <set-Cols
              :value="String(returnData.cols)"
              v-on:set="$set(returnData, 'cols', $event)"
            ></set-Cols>
          </v-col>
          <!--- ----->
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-checkbox v-model="rules3Flag" label="必須項目"></v-checkbox>
          </v-col>
          <v-col cols="3">
            <v-checkbox
              v-model="rules2Flag"
              label="初期値無し or 固定値"
            ></v-checkbox>
          </v-col>
          <v-col v-if="rules2Flag" cols="2">
            <v-text-field
              v-model="returnData.init"
              :rules="[validation.initFormat]"
              label="初期値"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="auto">
            <p>時間</p>
            <v-radio-group label="" v-model="rules[0]" column>
              <v-radio label="指定なし" value="0"></v-radio>
            </v-radio-group>
          </v-col>
          <p>分</p>
          <v-col>
            <v-radio-group label="" v-model="rules[1]" column>
              <v-radio label="指定なし" value="0"></v-radio>
              <!--あとから値を変更ついかしたせいで4  -->
              <v-radio label="5分単位" value="4"></v-radio>
              <v-radio label="10分単位" value="1"></v-radio>
              <v-radio label="15分単位" value="2"></v-radio>
              <v-radio label="30分単位" value="3"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        @click.once="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        x-large
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import setCols from "./common/setCols.vue";
export default {
  props: {
    label: String,
    init: String,
    type: Number,
    position: Number,
    cols: String,
    rule: String,
  },
  components: {
    setCols,
  },
  data() {
    return {
      returnData: {
        label: this.label,
        init: this.init,
        type: this.type,
        position: this.position,
        cols: this.cols,
        rule: this.rule,
      },
      rules: [],
      rules2Flag: false,
      rules3Flag: false,
      validation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        initFormat: (value) => {
          if (value == null || value == "") {
            return true;
          }
          return /^([0-9][0-9]:[0-9][0-9])$/.test(value) || "00:00形式で入力";
        },
      },
      backOpacity: "opacity: 1",
    };
  },
  mounted() {
    this.rules = this.rule.split(",");
    if (this.$store.state.nullCheck(this.rules[2])) {
      this.rules2Flag = true;
    }
    if (this.$store.state.nullCheck(this.rules[3])) {
      this.rules3Flag = true;
    }
    if (this.rules[4] != "null" && this.rules[4] != "small") {
      this.rules[4] = "null";
    }
  },
  methods: {
    submit() {
      if (this.$store.state.nullCheck(this.rules2Flag)) {
        this.rules[2] = "true";
      } else {
        this.rules[2] = "";
      }
      if (this.$store.state.nullCheck(this.rules3Flag)) {
        this.rules[3] = "true";
      } else {
        this.rules[3] = "";
      }
      this.returnData.rule = this.rules.join(",");
      this.$emit("clickSubmit", this.returnData);
    },
  },
};
</script>
